import {ReactNode} from "react";
import {RenderableDocument, DibJsonNode} from "../../types";
import {buildTopicUrl} from "../../contentUtils";
import {ExperimentalLink} from "../../../../components/ExperimentalLink";
import contentLinkClasses from "../contentLink.module.css";

export const JumpLink = ({
    node,
    map,
    children,
}: {
    node: DibJsonNode;
    map: RenderableDocument;
    children: ReactNode[];
}) => {
    const attrs = node.element?.attributes;
    const targetSegment = attrs?.["data-segment"] ?? "";
    const targetId = attrs?.["data-id"] ?? "";
    const currentSegment = map.segmentId;

    if (targetSegment === currentSegment) {
        return (
            <a href={`#${targetId}`} className={contentLinkClasses.navLink}>
                {children}
            </a>
        );
    }

    const href =
        buildTopicUrl(map.topictypeId, map.name, map.topicId, targetSegment) +
        `#${targetId}`;

    return (
        <ExperimentalLink href={href} className={contentLinkClasses.navLink}>
            {children}
        </ExperimentalLink>
    );
};
